import dayjs, { Dayjs } from 'dayjs';
import { CellRenderInfo } from 'pages/Optimisation/components/DateSelector/DateSelector.types';
import React from 'react';

interface CalendarDotProps {
  current: number | Dayjs;
  info: CellRenderInfo;
  isActive: boolean;
  dotColor?: string;
}

export const CalendarDot: React.FC<CalendarDotProps> = ({
  current,
  info,
  isActive,
  dotColor,
}) => {
  if (info.type === 'date') {
    const originNode = info.originNode as React.ReactElement<{
      children?: React.ReactNode;
      style?: React.CSSProperties;
    }>;

    return React.cloneElement(originNode, {
      ...originNode.props,
      style: { ...originNode.props.style, position: 'relative' },
      children: (
        <>
          {originNode.props.children ?? dayjs(current).format('D')}
          {isActive && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                right: 2,
                color: dotColor ?? 'rgba(121, 180, 188, 0.65)',
                fontSize: '20px',
              }}
            >
              •
            </div>
          )}
        </>
      ),
    });
  }

  return (
    // Default for: Month, Year, Decade
    React.cloneElement(info.originNode as React.ReactElement, {
      ...(info.originNode.props as object),
    })
  );
};
